import React from 'react';
import SideMenu, { SideMenuTitle, SideMenuLink } from '@amzn/meridian/side-menu';
import Row from '@amzn/meridian/row';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import arrowsUpAndDownTokens from '@amzn/meridian-tokens/base/icon/arrows-up-and-down';
import * as AppRoutes from 'src/routing/constants/routes';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import { Icons } from 'src/constants/general-media';
import './SideNav.scss';

interface SideNavStateProps {
    openSideMenu: boolean;
    accessibleTools: string[];
}

interface SideNavDispatchProps {
    updateOpenSideMenu: (openSideMenu: boolean) => void;
}

type Props = SideNavStateProps & SideNavDispatchProps;

class SideNav extends React.Component<Props> {

    private SORT = "Sort";

    private shouldToolBeVisible = (toolName: string): boolean => {
        return this.props.accessibleTools.includes(toolName);
    }

    public render() {
        return(
            <Row alignmentVertical={"stretch"}>
                <SideMenu open={this.props.openSideMenu} onClose={() => this.props.updateOpenSideMenu(false)} type={"overlay"}>
                    <SideMenuTitle>
                        <div className="side-nav-header">
                            <img src={Icons.RIV_ICON_SMALL} alt="" className="riv-small-logo"/>
                            <Heading level={6} type={"h50"}>{AppStrings.RIV_TITLE}</Heading>
                        </div>
                    </SideMenuTitle>
                    {this.shouldToolBeVisible(this.SORT) &&
                        <SideMenuLink
                            href={AppRoutes.SUB_SORT_PAGE_ROUTE}
                            selected={true}
                        >
                            <Icon tokens={arrowsUpAndDownTokens} />
                            <span className="side-nav-list-option">{AppStrings.SIDE_NAV_ITEM_SORT}</span>
                        </SideMenuLink>
                    }
                </SideMenu>
            </Row>
        );
    }
}

export default SideNav;